export enum ConfigureCustomArticleMode {
  CREATE_CUSTOM_ARTICLE, CONNECT_CUSTOM_ARTICLE, EDIT_CUSTOM_ARTICLE, VIEW_CUSTOM_ARTICLE
}
